module.exports = {
	"config": {
		"blogTitle": "Ben Schwab",
		"authorName": "Ben Schwab",
		"linkPrefix": ""
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md",
				"absolute": "/Users/Ben/Programming/personal-site/blog/404.md",
				"isAbsolute": false
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "about",
				"base": "_template.js",
				"ext": "js",
				"name": "_template",
				"extname": ".js",
				"basename": "_template.js",
				"dirname": "about",
				"stem": "_template",
				"path": "about/_template.js",
				"absolute": "/Users/Ben/Programming/personal-site/blog/about/_template.js",
				"isAbsolute": false
			},
			"requirePath": "about/_template.js",
			"templatePath": "/about/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "blog",
				"base": "_template.js",
				"ext": "js",
				"name": "_template",
				"extname": ".js",
				"basename": "_template.js",
				"dirname": "blog",
				"stem": "_template",
				"path": "blog/_template.js",
				"absolute": "/Users/Ben/Programming/personal-site/blog/blog/_template.js",
				"isAbsolute": false
			},
			"requirePath": "blog/_template.js",
			"templatePath": "/blog/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "blog/2015-05-01-hello-world",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "blog/2015-05-01-hello-world",
				"stem": "index",
				"path": "blog/2015-05-01-hello-world/index.md",
				"absolute": "/Users/Ben/Programming/personal-site/blog/blog/2015-05-01-hello-world/index.md",
				"isAbsolute": false
			},
			"requirePath": "blog/2015-05-01-hello-world/index.md",
			"path": "/hello-world/",
			"data": {
				"title": "Hello World",
				"date": "2015-05-01T22:12:03.284Z",
				"layout": "post",
				"readNext": "/my-second-post/",
				"path": "/hello-world/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blog/2015-05-06-my-second-post",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "blog/2015-05-06-my-second-post",
				"stem": "index",
				"path": "blog/2015-05-06-my-second-post/index.md",
				"absolute": "/Users/Ben/Programming/personal-site/blog/blog/2015-05-06-my-second-post/index.md",
				"isAbsolute": false
			},
			"requirePath": "blog/2015-05-06-my-second-post/index.md",
			"path": "/my-second-post/",
			"data": {
				"title": "My Second Post!",
				"date": "2015-05-06T23:46:37.121Z",
				"layout": "post",
				"readNext": "/hi-folks/",
				"path": "/my-second-post/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blog/2015-05-28-hi-folks",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "blog/2015-05-28-hi-folks",
				"stem": "index",
				"path": "blog/2015-05-28-hi-folks/index.md",
				"absolute": "/Users/Ben/Programming/personal-site/blog/blog/2015-05-28-hi-folks/index.md",
				"isAbsolute": false
			},
			"requirePath": "blog/2015-05-28-hi-folks/index.md",
			"path": "/hi-folks/",
			"data": {
				"title": "New Beginnings",
				"date": "2015-05-28T22:40:32.169Z",
				"layout": "post",
				"path": "/hi-folks/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blog/2016-12-9-react-component-post",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "blog/2016-12-9-react-component-post",
				"stem": "index",
				"path": "blog/2016-12-9-react-component-post/index.js",
				"absolute": "/Users/Ben/Programming/personal-site/blog/blog/2016-12-9-react-component-post/index.js",
				"isAbsolute": false
			},
			"requirePath": "blog/2016-12-9-react-component-post/index.js",
			"path": "/blog/2016-12-9-react-component-post/",
			"data": {
				"title": "A post written in Javascript!",
				"date": "2016-12-09T12:40:32.169Z"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blog/2016-12-9-react-component-post",
				"base": "single-date-picker.js",
				"ext": "js",
				"name": "single-date-picker",
				"extname": ".js",
				"basename": "single-date-picker.js",
				"dirname": "blog/2016-12-9-react-component-post",
				"stem": "single-date-picker",
				"path": "blog/2016-12-9-react-component-post/single-date-picker.js",
				"absolute": "/Users/Ben/Programming/personal-site/blog/blog/2016-12-9-react-component-post/single-date-picker.js",
				"isAbsolute": false
			},
			"requirePath": "blog/2016-12-9-react-component-post/single-date-picker.js",
			"path": "/blog/2016-12-9-react-component-post/single-date-picker/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "blog/android",
				"base": "_template.js",
				"ext": "js",
				"name": "_template",
				"extname": ".js",
				"basename": "_template.js",
				"dirname": "blog/android",
				"stem": "_template",
				"path": "blog/android/_template.js",
				"absolute": "/Users/Ben/Programming/personal-site/blog/blog/android/_template.js",
				"isAbsolute": false
			},
			"requirePath": "blog/android/_template.js",
			"templatePath": "/blog/android/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "blog/android",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "blog/android",
				"stem": "index",
				"path": "blog/android/index.js",
				"absolute": "/Users/Ben/Programming/personal-site/blog/blog/android/index.js",
				"isAbsolute": false
			},
			"requirePath": "blog/android/index.js",
			"path": "/blog/android/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "blog",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "blog",
				"stem": "index",
				"path": "blog/index.js",
				"absolute": "/Users/Ben/Programming/personal-site/blog/blog/index.js",
				"isAbsolute": false
			},
			"requirePath": "blog/index.js",
			"path": "/blog/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "blog/thoughts",
				"base": "_template.js",
				"ext": "js",
				"name": "_template",
				"extname": ".js",
				"basename": "_template.js",
				"dirname": "blog/thoughts",
				"stem": "_template",
				"path": "blog/thoughts/_template.js",
				"absolute": "/Users/Ben/Programming/personal-site/blog/blog/thoughts/_template.js",
				"isAbsolute": false
			},
			"requirePath": "blog/thoughts/_template.js",
			"templatePath": "/blog/thoughts/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "blog/thoughts",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "blog/thoughts",
				"stem": "index",
				"path": "blog/thoughts/index.js",
				"absolute": "/Users/Ben/Programming/personal-site/blog/blog/thoughts/index.js",
				"isAbsolute": false
			},
			"requirePath": "blog/thoughts/index.js",
			"path": "/blog/thoughts/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js",
				"absolute": "/Users/Ben/Programming/personal-site/blog/index.js",
				"isAbsolute": false
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 378
// module chunks = 0